<template>
  <div class="cemiterio-dashboard">
    <div class="header">
      <h2>{{ greetingMessage }}</h2>
      <el-button @click="userStore.logout()" type="primary">Logout</el-button>
    </div>
    <div class="dashboard-container">
      <!-- Main Content (Tabs) -->
      <div class="main-content">
        <el-tabs v-model="activeTab">
          <!-- Criar Vaga Tab -->
          <el-tab-pane label="Criar Vaga" name="createVaga">
            <div class="tab-content">
              <h3>Criar Nova Vaga</h3>
              <el-form :model="newVaga" ref="vagaFormRef" :rules="rules" label-position="top">
                <el-form-item label="Quadra (Não utilizar 0 inicial)" prop="quadra">
                  <el-input v-model="newVaga.quadra" />
                </el-form-item>
                <el-form-item label="Número Sepultura (Não utilizar 0 inicial)" prop="numeroSepultura">
                  <el-input v-model="newVaga.numeroSepultura" />
                </el-form-item>
                <el-form-item label="Tipo" prop="grave_type">
                  <el-select v-model="newVaga.tipo" placeholder="Selecione um tipo...">
                    <el-option label="Carneira" value="Carneira" />
                    <el-option label="Carneira Anjo" value="Carneira Anjo" />
                    <el-option label="Gaveta" value="Gaveta" />
                    <el-option label="Gaveta Anjo" value="Gaveta Anjo" />
                    <el-option label="Perpétua - Gaveta" value="Perpétua - Gaveta" />
                    <el-option label="Perpétua - Carneira" value="Perpétua - Carneira" />
                    <el-option label="Banqueta" value="Banqueta" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Disponível?" prop="disponivel">
                  <el-switch
                      v-model="newVaga.disponivel"
                      active-value="true"
                      inactive-value="false"
                  />
                </el-form-item>
                <el-form-item label="Obeso?" prop="obeso">
                  <el-switch
                      v-model="newVaga.obeso"
                      :active-value="true"
                      :inactive-value="false"
                  />
                </el-form-item>
                <el-form-item
                    label="Altura (Preencher se Obeso, em centimetros (1,20m = 120cm))"
                    prop="altura"
                >
                  <el-input v-model="newVaga.altura" />
                </el-form-item>
                <el-form-item
                    label="Largura (Preencher se Obeso, em centimetros (1,20m = 120cm))"
                    prop="largura"
                >
                  <el-input v-model="newVaga.largura" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="createVaga" :disabled="!canEdit">
                    Criar Vaga
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>

          <!-- Mapa do Cemiterio Tab -->
          <el-tab-pane label="Mapa do Cemiterio" name="mapa">
            <div class="tab-content mapa-container">
              <!-- Filtro de data e download do PDF -->
              <div class="filtro">
                <div style="margin-top: 10px;">
                  <span>Baixar Mapa:</span>
                  <el-radio-group v-model="mapDownloadMode" style="margin-left: 10px;">
                    <el-radio label="dia_exato">Dia Exato</el-radio>
                    <el-radio label="intervalo">Intervalo</el-radio>
                  </el-radio-group>
                </div>
                <div style="margin-top: 10px;">
                  <el-date-picker
                      v-if="mapDownloadMode === 'dia_exato'"
                      v-model="selectedDate"
                      type="date"
                      placeholder="Selecione a data"
                  />
                  <div v-else>
                    <el-date-picker
                        v-model="startDate"
                        type="date"
                        placeholder="Data de Início"
                        style="margin-right: 10px;"
                        :disabledDate="disabledStartDate"
                    />
                    <el-date-picker
                        v-model="endDate"
                        type="date"
                        placeholder="Data Final"
                        :disabledDate="disabledEndDate"
                    />
                  </div>
                  <el-button type="primary" @click="downloadPDFMap" style="margin-left: 10px;">
                    Baixar PDF
                  </el-button>
                </div>
              </div>
              <h3 class="mt-20">Mapa do Cemiterio</h3>
              <el-input v-model="cemiterioMapaFilter" placeholder="Filtrar mapa..." style="margin: 10px 0; max-width: 300px;" />
              <el-table :data="filteredCemiterioMapaData" class="mt-20" style="width: 100%">
                <!-- Quadra -->
                <el-table-column label="Quadra" width="80">
                  <template #default="{ row }">
                    {{ row.vaga?.quadra || 'N/A' }}
                  </template>
                </el-table-column>
                <!-- Nº Sepultura -->
                <el-table-column label="Sepultura" width="80">
                  <template #default="{ row }">
                    {{ row.vaga?.numeroSepultura || 'N/A' }}
                  </template>
                </el-table-column>
                <!-- Tipo -->
                <el-table-column label="Tipo">
                  <template #default="{ row }">
                    <span>
                      {{ row.vaga.tipo || 'N/A' }}
                      <template v-if="row.vaga.obeso">
                        (A:{{ row.vaga.altura }} L:{{ row.vaga.largura }})
                      </template>
                    </span>
                  </template>
                </el-table-column>
                <!-- Funerária -->
                <el-table-column label="Funerária">
                  <template #default="{ row }">
                    {{ row.funeraria?.nome || 'N/A' }}
                  </template>
                </el-table-column>
                <!-- Nome do Falecido -->
                <el-table-column label="Nome do Falecido">
                  <template #default="{ row }">
                    {{ row.nomeFalecido || 'N/A' }}
                  </template>
                </el-table-column>
                <!-- Falecido Obeso? -->
                <el-table-column label="Obeso?" width="90">
                  <template #default="{ row }">
                    {{ row.obeso ? 'Sim' : 'Não' }}
                  </template>
                </el-table-column>
                <!-- CPF -->
                <el-table-column label="Documento">
                  <template #default="{ row }">
                    {{ row.tipoDocumento || 'Documento Nao Especificado'}} {{ row.cpfFalecido || 'N/A' }}
                  </template>
                </el-table-column>
                <!-- Data e Hora -->
                <el-table-column label="Data e Hora">
                  <template #default="{ row }">
                    {{ formatDateCell(null, null, row.dataRequisicao) }} {{ row.horaRequisicao || '' }}
                  </template>
                </el-table-column>
                <!-- Confirmação -->
                <el-table-column label="Confirmação">
                  <template #default="{ row }">
                    {{ formatDateToRio(row.confirmDateTime) }}
                  </template>
                </el-table-column>
                <!-- Horário Real de Sepultamento -->
                <el-table-column label="Horário Real de Sepultamento">
                  <template #default="{ row }">
                    {{ formatDateToRio(row.horarioSepultamento) }}
                  </template>
                </el-table-column>
                <!-- Ações -->
                <el-table-column label="Ações" width="160">
                  <template #default="{ row }">
                    <el-button
                        type="primary"
                        size="small"
                        @click="openConfirmDialog(row)"
                        v-if="row.status !== 'CONFIRMADO'"
                        style="margin-right: 12px;"
                    >
                      Confirmar Sepultamento
                    </el-button>
                  </template>
                </el-table-column>
                <!-- Status -->
                <el-table-column label="Status">
                  <template #default="{ row }">
                    {{ row.status || 'N/A' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Registro de Livro" name="registroLivro">
            <div class="tab-content">
              <h3>Registro de Livro</h3>
              <el-alert
                type="info"
                :closable="false"
                show-icon
                title="Como preencher o livro"
                description="O registro do livro é preenchido ao confirmar um sepultamento, na aba 'Mapa do Cemiterio': clique em Confirmar numa requisição permitida e um formulário já preenchido com os dados da requisição/vaga será aberto para você completar os campos restantes."
                style="margin-bottom: 12px;"
              />

              <div style="display: flex; align-items: center; gap: 12px; margin-top: 24px;">
                <h3 style="margin: 0;">Registros</h3>
                <el-button size="small" type="primary" plain @click="refreshRegistrosLivro">Atualizar</el-button>
                <span style="font-size: 12px; color: #909399;">Clique numa linha para ver a entrada completa.</span>
              </div>
              <PaginatedTable
                ref="registroLivroTableRef"
                api-endpoint="/registros-livro/paginated"
                :show-filters="true"
                style="margin-top: 12px;"
                @row-click="openRegistroDetail"
              >
                <template #filters="{ filters, updateFilter }">
                  <el-col :span="6" v-for="f in livroFilterFields" :key="f.key">
                    <el-form-item :label="f.label">
                      <el-date-picker
                        v-if="f.type === 'date'"
                        :model-value="filters[f.key]"
                        @update:model-value="(v) => updateFilter(f.key, v)"
                        type="date"
                        value-format="YYYY-MM-DD"
                        style="width: 100%;"
                        clearable
                      />
                      <el-input
                        v-else
                        :model-value="filters[f.key]"
                        @input="(v) => updateFilter(f.key, v)"
                        clearable
                      />
                    </el-form-item>
                  </el-col>
                </template>
                <el-table-column prop="numeroOrdem" label="Nº Ordem" min-width="90" />
                <el-table-column prop="nomeFalecido" label="Falecido" min-width="160" show-overflow-tooltip />
                <el-table-column prop="data" label="Data" min-width="110" />
                <el-table-column prop="tipoSepultura" label="Tipo Sep." min-width="110" />
                <el-table-column prop="quadra" label="Quadra" min-width="80" />
                <el-table-column prop="numeroSepultura" label="Nº Sep." min-width="90" />
                <el-table-column prop="nomeResponsavel" label="Responsável" min-width="150" show-overflow-tooltip />
              </PaginatedTable>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- Right Panel: Vagas do Cemitério (exibido somente se a aba ativa não for "Mapa do Cemiterio") -->
      <div class="right-panel" v-if="activeTab !== 'mapa' && activeTab !== 'registroLivro'">
        <div style="display: flex; align-items: center; gap: 12px;">
          <h3 style="margin: 0;">Vagas do Cemitério</h3>
          <el-button size="small" type="primary" plain @click="fetchCemiterioVagas">
            Atualizar
          </el-button>
        </div>
        <el-input v-model="cemiterioVagasFilter" placeholder="Filtrar vagas..." style="margin: 10px 0; max-width: 300px;" />
        <el-table :data="filteredCemiterioVagas" style="margin-top: 20px; width: 100%">
          <el-table-column prop="id" label="ID" />
          <el-table-column prop="section" label="Quadra" />
          <el-table-column prop="grave_number" label="Nº Sepultura" />
          <el-table-column label="Tipo">
            <template #default="{ row }">
              <span>
                {{ row.grave_type || 'N/A' }}
                <template v-if="row.is_obese">
                  (Obeso — A:{{ row.height_cm !== null ? row.height_cm : 'N/A' }} L:{{ row.width_cm !== null ? row.width_cm : 'N/A' }})
                </template>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Ações" width="100">
            <template #default="{ row }">
              <el-button v-if="canEditPrivileged" size="small" @click="openEditVagaDialog(row)">Editar</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- Confirmar Sepultamento + Registro de Livro Dialog -->
    <el-dialog v-model="confirmDialogVisible" title="Confirmar Sepultamento e Registrar no Livro" width="820px">
      <div v-if="confirmRow">
        <p style="margin: 0 0 4px;"><b>Falecido:</b> {{ confirmRow.nomeFalecido }}</p>
        <p style="margin: 0 0 12px;"><b>Vaga:</b>
          Quadra {{ confirmRow.vaga ? confirmRow.vaga.quadra : 'N/A' }} /
          Nº {{ confirmRow.vaga ? confirmRow.vaga.numeroSepultura : 'N/A' }} /
          Tipo {{ confirmRow.vaga ? confirmRow.vaga.tipo : 'N/A' }}
        </p>
        <el-form ref="registroFormRef" :model="registroExtras" :rules="registroRules" label-position="top">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="Data do Sepultamento" prop="data">
                <el-date-picker v-model="registroExtras.data" type="date" placeholder="Selecione" style="width: 100%;" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Nº da Ordem (livro)" prop="numeroOrdem">
                <el-input v-model="registroExtras.numeroOrdem" />
              </el-form-item>
            </el-col>
            <el-col :span="8"><el-form-item label="Filiação" prop="filiacao"><el-input v-model="registroExtras.filiacao" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Sexo" prop="sexo"><el-input v-model="registroExtras.sexo" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Estado Civil" prop="estadoCivil"><el-input v-model="registroExtras.estadoCivil" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Idade" prop="idade"><el-input v-model="registroExtras.idade" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Profissão" prop="profissao"><el-input v-model="registroExtras.profissao" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Naturalidade" prop="naturalidade"><el-input v-model="registroExtras.naturalidade" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Residência do Responsável" prop="residenciaResponsavel"><el-input v-model="registroExtras.residenciaResponsavel" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Telefone de Contato" prop="telefoneContato"><el-input v-model="registroExtras.telefoneContato" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Referência Externa (outro nº de ordem)" prop="referenciaExterna"><el-input v-model="registroExtras.referenciaExterna" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Causa da Morte" prop="causaMorte"><el-input v-model="registroExtras.causaMorte" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Médico (atestado de óbito)" prop="medicoAtestado"><el-input v-model="registroExtras.medicoAtestado" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Data da Exumação" prop="dataExumacao"><el-date-picker v-model="registroExtras.dataExumacao" type="date" placeholder="Selecione" style="width: 100%;" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="Nome do Responsável" prop="nomeResponsavel"><el-input v-model="registroExtras.nomeResponsavel" /></el-form-item></el-col>
            <el-col :span="8"><el-form-item label="CPF do Responsável" prop="cpfResponsavel"><el-input v-model="registroExtras.cpfResponsavel" /></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="Observações" prop="observacoes"><el-input v-model="registroExtras.observacoes" type="textarea" :rows="3" /></el-form-item></el-col>
          </el-row>
        </el-form>
      </div>
      <template #footer>
        <el-button @click="confirmDialogVisible = false">Cancelar</el-button>
        <el-button type="primary" :loading="confirmSubmitting" @click="submitConfirmSepultamento">Confirmar e Registrar</el-button>
      </template>
    </el-dialog>

    <!-- Registro de Livro: detalhe da entrada -->
    <el-dialog v-model="registroDetailVisible" title="Registro de Livro — entrada completa" width="760px">
      <div v-if="registroDetailRow">
        <el-row :gutter="16">
          <el-col :span="12" v-for="f in livroDetailFields" :key="f.key" style="margin-bottom: 8px;">
            <div style="font-size: 12px; color: #909399;">{{ f.label }}</div>
            <div style="font-weight: 500; white-space: pre-wrap;">{{ registroCellValue(registroDetailRow, f) || '—' }}</div>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <el-button @click="registroDetailVisible = false">Fechar</el-button>
      </template>
    </el-dialog>

    <!-- Edit Vaga Dialog -->
    <el-dialog v-model="editVagaDialogVisible" title="Editar Vaga">
      <el-form :model="editVagaForm" label-position="top">
        <el-form-item label="Quadra" prop="section">
          <el-input v-model="editVagaForm.quadra" />
        </el-form-item>
        <el-form-item label="Número Sepultura" prop="grave_number">
          <el-input v-model="editVagaForm.numeroSepultura" />
        </el-form-item>
        <el-form-item label="Tipo" prop="grave_type">
          <el-select v-model="editVagaForm.tipo" placeholder="Selecione um tipo">
            <el-option label="Carneira" value="Carneira" />
            <el-option label="Carneira Anjo" value="Carneira Anjo" />
            <el-option label="Gaveta" value="Gaveta" />
            <el-option label="Gaveta Anjo" value="Gaveta Anjo" />
            <el-option label="Perpétua - Gaveta" value="Perpétua - Gaveta" />
            <el-option label="Perpétua - Carneira" value="Perpétua - Carneira" />
            <el-option label="Banqueta" value="Banqueta" />
          </el-select>
        </el-form-item>
        <el-form-item label="Disponível" prop="disponivel">
          <el-switch
              v-model="editVagaForm.disponivel"
              :active-value="true"
              :inactive-value="false"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editVagaDialogVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="updateVaga">Salvar</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import apiClient from '@/plugins/axios';
import { ElMessage } from 'element-plus';
import { useUserStore } from '@/stores/user';
import PaginatedTable from '@/components/PaginatedTable.vue';

const userStore = useUserStore();
const activeTab = ref('createVaga');

// --- Criar Vaga ---
const newVaga = ref({
  quadra: '',
  numeroSepultura: '',
  tipo: '',
  disponivel: true,
  obeso: false,
  altura: '',
  largura: ''
});
const vagaFormRef = ref(null);
const createVaga = async () => {
  if (!vagaFormRef.value) return;

  // Validação: se "Obeso" estiver ativado, os campos Altura e Largura devem ser preenchidos
  if (newVaga.value.obeso && (!newVaga.value.altura || !newVaga.value.largura)) {
    return ElMessage.error('Preencha os campos Altura e Largura para vagas "Obeso".');
  }

  try {
    await apiClient.post('/vagas', newVaga.value);
    ElMessage.success('Vaga criada com sucesso!');
    Object.assign(newVaga.value, {
      quadra: '',
      numeroSepultura: '',
      tipo: '',
      disponivel: true,
      obeso: false,
      altura: '',
      largura: ''
    });
    fetchCemiterioVagas();
  } catch (error) {
    ElMessage.error(error.response?.data?.message || 'Erro ao criar vaga');
  }
};

// --- Mapa do Cemiterio ---
const mapDownloadMode = ref("dia_exato"); // 'dia_exato' ou 'intervalo'
const selectedDate = ref(new Date().toISOString().split("T")[0]);
const startDate = ref(null);
const endDate = ref(null);
const cemiterioMapaData = ref([]);
const cemiterioMapaFilter = ref("");

// Funções para desabilitar datas fora do intervalo permitido
const disabledStartDate = (date) => {
  if (endDate.value) {
    const oneYearBefore = new Date(endDate.value);
    oneYearBefore.setFullYear(oneYearBefore.getFullYear() - 1);
    return date.getTime() < oneYearBefore.getTime() || date.getTime() > new Date(endDate.value).getTime();
  }
  return false;
};
const disabledEndDate = (date) => {
  if (startDate.value) {
    const oneYearAfter = new Date(startDate.value);
    oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);
    return date.getTime() < new Date(startDate.value).getTime() || date.getTime() > oneYearAfter.getTime();
  }
  return false;
};

const fetchCemiterioMapa = async () => {
  try {
    let params = {};
    let endpoint = "";
    if (mapDownloadMode.value === "dia_exato") {
      if (!selectedDate.value) return;
      params.data = selectedDate.value;
      endpoint = "/requisicoes/mapa";
    } else {
      if (!startDate.value || !endDate.value) return;
      params.dataInicio = startDate.value;
      params.dataFinal = endDate.value;
      endpoint = "/requisicoes/mapa/intervalo";
    }
    // Usa o id do cemitério atrelado ao usuário
    if (userStore.user?.cemiterio?.id) {
      params.cemiterio = userStore.user.cemiterio.id;
    }
    const { data } = await apiClient.get(endpoint, { params });
    console.log('API Mapa Response:', data); // Debug log
    cemiterioMapaData.value = data;
  } catch (error) {
    ElMessage.error("Erro ao buscar mapa do cemitério");
  }
};

const downloadPDFMap = async () => {
  try {
    let params = {};
    let endpoint = "";
    if (mapDownloadMode.value === "dia_exato") {
      if (!selectedDate.value) return;
      params.data = selectedDate.value;
      endpoint = "/requisicoes/mapa/pdf";
    } else {
      if (!startDate.value || !endDate.value) return;
      params.dataInicio = startDate.value;
      params.dataFinal = endDate.value;
      endpoint = "/requisicoes/mapa/intervalo/pdf";
    }
    if (userStore.user?.cemiterio?.id) {
      params.cemiterio = userStore.user.cemiterio.id;
    }
    const response = await apiClient.get(endpoint, { params, responseType: "blob" });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", mapDownloadMode.value === "dia_exato" ? "mapa_cemiterio.pdf" : "mapa_cemiterio_intervalo.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    ElMessage.error("Erro ao baixar o PDF do mapa");
  }
};

// Adicione as funções de formatação de data para replicar a lógica do Admin Prefeitura
function formatDateToRio(dateString) {
  console.log('formatDateToRio input:', dateString); // Debug log
  if (!dateString) return 'Não Informado!';
  const optionsDate = { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric' };
  const optionsTime = { timeZone: 'America/Sao_Paulo', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' };

  if (dateString.length === 10) {
    const dateObj = new Date(dateString + "T00:00:00");
    return dateObj.toLocaleDateString('pt-BR', optionsDate);
  } else {
    const dateObj = new Date(dateString);
    const timeStr = dateObj.toLocaleTimeString('pt-BR', optionsTime);
    const dateStr = dateObj.toLocaleDateString('pt-BR', optionsDate);
    return `${timeStr} ${dateStr}`;
  }
}

function formatDateCell(row, column, cellValue) {
  return cellValue ? formatDateToRio(cellValue) : 'N/A';
}

const filteredCemiterioMapaData = computed(() => {
  if (!cemiterioMapaFilter.value) return cemiterioMapaData.value;
  return cemiterioMapaData.value.filter(row =>
    JSON.stringify(row).toLowerCase().includes(cemiterioMapaFilter.value.toLowerCase())
  );
});

watch([selectedDate, startDate, endDate, mapDownloadMode], () => {
  fetchCemiterioMapa();
});

// Add watcher for tab change to refresh Mapa table
watch(activeTab, (newTab) => {
  if (newTab === 'mapa') {
    fetchCemiterioMapa();
  } else if (newTab === 'registroLivro') {
    refreshRegistrosLivro();
  }
});

// --- Vagas do Cemitério (Right Panel) ---
const cemiterioVagas = ref([]);
const cemiterioVagasFilter = ref("");

const filteredCemiterioVagas = computed(() => {
  if (!cemiterioVagasFilter.value) return cemiterioVagas.value;
  return cemiterioVagas.value.filter(row =>
    JSON.stringify(row).toLowerCase().includes(cemiterioVagasFilter.value.toLowerCase())
  );
});

const fetchCemiterioVagas = async () => {
  try {
    const cemiterioId = userStore.user?.cemiterio?.id;
    if (!cemiterioId) return;
    const { data } = await apiClient.get(`/cemiterios/${cemiterioId}/vagas`);
    cemiterioVagas.value = data;
  } catch (error) {
    // Tratamento de erro, se necessário
  }
};

const editVagaDialogVisible = ref(false);
const editVagaForm = ref({
  id: '',
  quadra: '',
  numeroSepultura: '',
  tipo: '',
  disponivel: true,
});
// Store the initial data for diffing
const initialVagaData = ref(null);

// Utility: Build diff payload
function buildVagaDiffPayload(initial, current) {
  const payload = {};
  for (const key in current) {
    if (key === 'cemiterio') {
      // If cemiterio changed, send only the id
      const initialId = initial?.cemiterio?.id || initial?.cemiterio;
      const currentId = current?.cemiterio?.id || current?.cemiterio;
      if (initialId !== currentId) {
        payload.cemiterio = currentId;
      }
    } else if (JSON.stringify(current[key]) !== JSON.stringify(initial?.[key])) {
      payload[key] = current[key];
    }
  }
  return payload;
}

// Abre o diálogo de edição mapeando as colunas cruas (section/grave_number/
// grave_type/is_available) para os campos do formulário.
// Allowlist de edição (consultada no backend).
const canEditPrivileged = ref(false);
const fetchEditAccess = async () => {
  try {
    const { data } = await apiClient.get('/requisicoes/edit-access');
    canEditPrivileged.value = !!data.allowed;
  } catch (error) {
    canEditPrivileged.value = false;
  }
};

const openEditVagaDialog = (row) => {
  if (!canEditPrivileged.value) {
    ElMessage.error('Você não tem permissão para editar vagas.');
    return;
  }
  editVagaForm.value = {
    id: row.id,
    quadra: row.section,
    numeroSepultura: row.grave_number,
    tipo: row.grave_type,
    disponivel: row.is_available,
  };
  initialVagaData.value = { ...editVagaForm.value };
  editVagaDialogVisible.value = true;
};

const updateVaga = async () => {
  try {
    const payload = buildVagaDiffPayload(initialVagaData.value, editVagaForm.value);
    await apiClient.patch(`/vagas/${editVagaForm.value.id}`, payload);
    ElMessage.success('Vaga atualizada com sucesso!');
    editVagaDialogVisible.value = false;
    fetchCemiterioVagas();
  } catch (error) {
    ElMessage.error('Erro ao atualizar vaga');
  }
};
// #3 Cemitério: Registro de Livro
const registroLivroTableRef = ref(null);
const refreshRegistrosLivro = () => {
  if (registroLivroTableRef.value) registroLivroTableRef.value.refresh();
};

const formatRegistroDate = (d) => {
  if (!d) return null;
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = (dt.getMonth() + 1).toString().padStart(2, '0');
  const day = dt.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${day}`;
};

// Filtros e detalhe do registro de livro.
const livroFilterFields = [
  { key: 'numeroOrdem', label: 'Nº Ordem' },
  { key: 'nomeFalecido', label: 'Falecido' },
  { key: 'data', label: 'Data', type: 'date' },
  { key: 'filiacao', label: 'Filiação' },
  { key: 'sexo', label: 'Sexo' },
  { key: 'estadoCivil', label: 'Estado Civil' },
  { key: 'idade', label: 'Idade' },
  { key: 'profissao', label: 'Profissão' },
  { key: 'naturalidade', label: 'Naturalidade' },
  { key: 'residenciaResponsavel', label: 'Residência do Responsável' },
  { key: 'telefoneContato', label: 'Telefone' },
  { key: 'referenciaExterna', label: 'Referência Externa' },
  { key: 'causaMorte', label: 'Causa da Morte' },
  { key: 'medicoAtestado', label: 'Médico (atestado)' },
  { key: 'tipoSepultura', label: 'Tipo de Sepultura' },
  { key: 'numeroSepultura', label: 'Nº Sepultura' },
  { key: 'quadra', label: 'Quadra' },
  { key: 'dataExumacao', label: 'Data da Exumação', type: 'date' },
  { key: 'nomeResponsavel', label: 'Nome do Responsável' },
  { key: 'cpfResponsavel', label: 'CPF do Responsável' },
  { key: 'observacoes', label: 'Observações' },
];
const livroDetailFields = [
  ...livroFilterFields,
  { key: 'cemiterio', label: 'Cemitério', type: 'cemiterio' },
  { key: 'createdBy', label: 'Preenchido por', type: 'user' },
  { key: 'createdAt', label: 'Registrado em', type: 'datetime' },
];
const registroDetailVisible = ref(false);
const registroDetailRow = ref(null);
const openRegistroDetail = (row) => {
  registroDetailRow.value = row;
  registroDetailVisible.value = true;
};
const registroCellValue = (row, f) => {
  if (f.type === 'cemiterio') return row.cemiterio ? row.cemiterio.nome : '';
  if (f.type === 'user') return row.createdBy ? `${row.createdBy.nome} (${row.createdBy.role})` : '';
  const v = row[f.key];
  if (v === null || v === undefined) return '';
  if (f.type === 'datetime') {
    const d = new Date(v);
    return isNaN(d.getTime()) ? String(v) : d.toLocaleString('pt-BR');
  }
  return String(v);
};

// Confirmação de sepultamento + registro de livro (extras preenchidos no diálogo).
const registroExtrasVazio = () => ({
  data: new Date(), numeroOrdem: '', filiacao: '', sexo: '', estadoCivil: '',
  idade: '', profissao: '', naturalidade: '', residenciaResponsavel: '',
  telefoneContato: '', referenciaExterna: '', causaMorte: '', medicoAtestado: '',
  dataExumacao: null, nomeResponsavel: '', cpfResponsavel: '', observacoes: '',
});
const confirmDialogVisible = ref(false);
const confirmRow = ref(null);
const confirmSubmitting = ref(false);
const registroExtras = ref(registroExtrasVazio());
const registroFormRef = ref(null);

const requiredRule = [{ required: true, message: 'Obrigatório', trigger: 'blur' }];
const registroRules = {
  data: requiredRule,
  numeroOrdem: requiredRule,
  filiacao: requiredRule,
  sexo: requiredRule,
  estadoCivil: requiredRule,
  idade: requiredRule,
  profissao: requiredRule,
  naturalidade: requiredRule,
  residenciaResponsavel: requiredRule,
  // telefoneContato is optional
  referenciaExterna: requiredRule,
  causaMorte: requiredRule,
  medicoAtestado: requiredRule,
  dataExumacao: requiredRule,
  nomeResponsavel: requiredRule,
  cpfResponsavel: requiredRule,
  observacoes: requiredRule,
};

const openConfirmDialog = (row) => {
  confirmRow.value = row;
  registroExtras.value = registroExtrasVazio();
  confirmDialogVisible.value = true;
};

const submitConfirmSepultamento = async () => {
  if (!confirmRow.value) return;
  if (!registroFormRef.value) return;
  try {
    await registroFormRef.value.validate();
  } catch (err) {
    return;
  }
  confirmSubmitting.value = true;
  try {
    const e = registroExtras.value;
    const registro = {
      numeroOrdem: e.numeroOrdem,
      filiacao: e.filiacao,
      sexo: e.sexo,
      estadoCivil: e.estadoCivil,
      idade: e.idade,
      profissao: e.profissao,
      naturalidade: e.naturalidade,
      residenciaResponsavel: e.residenciaResponsavel,
      telefoneContato: e.telefoneContato,
      observacoes: e.observacoes,
      referenciaExterna: e.referenciaExterna,
      causaMorte: e.causaMorte,
      medicoAtestado: e.medicoAtestado,
      nomeResponsavel: e.nomeResponsavel,
      cpfResponsavel: e.cpfResponsavel,
      data: formatRegistroDate(e.data),
      dataExumacao: formatRegistroDate(e.dataExumacao),
    };
    const confirmDateTime = new Date().toISOString();
    await apiClient.patch(`/requisicoes/${confirmRow.value.id}/confirm`, {
      confirmDateTime,
      registro,
    });
    ElMessage.success('Sepultamento confirmado e registrado no livro!');
    confirmDialogVisible.value = false;
    fetchCemiterioMapa();
    refreshRegistrosLivro();
  } catch (error) {
    ElMessage.error(error.response?.data?.message || 'Erro ao confirmar sepultamento');
  } finally {
    confirmSubmitting.value = false;
  }
};

const canEdit = computed(() => userStore.role === 'cemiterio');

const greetingMessage = computed(() => {
  const now = new Date();
  const hour = now.getHours();
  let greeting = 'Bom dia';
  if (hour >= 18 || hour < 5) {
    greeting = 'Boa noite';
  } else if (hour >= 12) {
    greeting = 'Boa tarde';
  }
  const nome = userStore.user && userStore.user.nome ? userStore.user.nome : 'Usuário';
  const cemiterioNome = userStore.user && userStore.user.cemiterio && userStore.user.cemiterio.nome ? userStore.user.cemiterio.nome : 'Cemitério';
  return `${greeting}, ${nome} (${cemiterioNome})`;
});

onMounted(() => {
  fetchCemiterioVagas();
  fetchCemiterioMapa();
  fetchEditAccess();
});
</script>

<style scoped>
.cemiterio-dashboard {
  padding: 12px 24px;
  box-sizing: border-box;
  width: 100%;
  max-width: none;
}
.dashboard-container {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}
.main-content {
  flex: 2;
}
.right-panel {
  flex: 1;
}
.tab-content {
  margin-top: 20px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mapa-container {
  padding: 20px;
}
.filtro {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.mt-20 {
  margin-top: 20px;
}
</style>
